import { useNavigate } from "react-router-dom";
import { useHandleSignInCallback } from "@logto/react";

export function CallbackPage() {
  const navigate = useNavigate();

  const { isLoading } = useHandleSignInCallback(() => {
    navigate("/dashboard", { replace: true });
  });

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-center space-y-4">
          <div className="h-8 w-8 mx-auto border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-muted-foreground">Completamento autenticazione...</p>
        </div>
      </div>
    );
  }

  return null;
}
